import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  id: "artists-search-component",
  class: "o-artistsSearchComponent"
}
const _hoisted_2 = { class: "l-container l-bg-primary clearfix" }
const _hoisted_3 = {
  key: 0,
  class: "artists-search-results-list"
}
const _hoisted_4 = { class: "m-searchList__loadMore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInputComponent = _resolveComponent("SearchInputComponent")!
  const _component_Artist = _resolveComponent("Artist")!
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePushToDataLayer($event))),
        "data-js": "artists-search-form"
      }, [
        _createVNode(_component_SearchInputComponent, {
          label: _ctx.searchLabel,
          artistSearch: true,
          name: 'artist-search',
          icon: _ctx.IconName.Search
        }, null, 8, ["label", "icon"])
      ], 32)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
      type: "application/ld+json",
      innerHTML: _ctx.artistsStructuredData
    }, null, 8, ["innerHTML"])),
    (_ctx.artists)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artists, (artist) => {
            return (_openBlock(), _createElementBlock("li", {
              key: artist.url
            }, [
              _createVNode(_component_Artist, { item: artist }, null, 8, ["item"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_SpinnerComponent, { label: "" }, null, 512), [
      [_vShow, this.SearchResults.inProgress]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("button", {
        class: "a-btnCta -action",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
      }, null, 512), [
        [_directive_translate, { key: _ctx.Translation.More_search_results }]
      ])
    ], 512), [
      [_vShow, _ctx.canLoadMore]
    ])
  ]))
}